import 'react-hot-loader/patch'
import * as React from 'react'
import { render } from 'react-dom'
import { AppContainer } from 'react-hot-loader'

import App from './App'

const root = document.getElementById('app')

const update = () => render(
  <React.Fragment>
    <AppContainer warnings={false}>
      <App/>
    </AppContainer>
  </React.Fragment>,
  root
)

update()

if (module.hot) {
  module.hot.accept(update)
}
